const content = {
  title: {
    pageTitle: "Founders Sales Incentive{symbol} Report",
    tileTitleMobile: "FSI Tracking",
  },
  tabs: {
    inFsi: "In FSI Program",
    outFsi: "Out of FSI Program",
  },
  table: {
    columns: {
      aboName: "ABO Name",
      ppvActual: "PPV",
      ppvNeeded: "PPV Needed",
      vcsPvActual: "VCS PV",
      vcsPvNeeded: "VCS PV Needed",
      vcsPercent: "VCS %",
      accumulatedVcsBv: "Accumulated VCS BV",
      exitMonth: "Exit Month",
    },
  },
  export: {
    title: "Export Report",
    descriptionInFsi: "This report will include a list of all ABOs tracking for the Founders Sales Incentive{symbol}.",
    descriptionOutFsi:
      "This report will include a list of all ABOs who are no longer tracking for the Founders Sales Incentive{symbol}.",
    exportTypeLabel: "Founders Sales Incentive{symbol} Report",
  },
  emptyState: {
    noResults: "No ABOs match this criteria.",
  },
} as const;

export default content;
